var jingdian = [
    // —————— 环翠区（主城区） ——————
    [122.183090, 37.502573, '刘公岛风景区'],
    [122.181412,37.501484, '甲午战争博物馆'],
    [122.049889, 37.530402, '威海国际海水浴场'],
    [122.144823, 37.465201, '威海公园'],
    [122.127677, 37.501473, '幸福门广场'],
    [122.161056,37.446979, '悦海公园'],
    [122.153800, 37.427908, '韩乐坊'],
    [122.120519, 37.513315, '威海市博物馆'],
    [122.123236, 37.490537, '塔山森林公园'],
    [122.085458, 37.472961, '里口山风景名胜区'],

    // —————— 亲子乐园 & 儿童友好型重点景区 ——————
    [122.377012, 37.410875, '奇遇小螺号成长乐园'],
    [122.092552, 37.184398, '珊瑚岛亲子乐园'],
    [122.043889,37.475305, '瑾博熊猫亲子乐园'],
    [122.160741, 37.373230, '泉乐坊欢乐世界'],
    [122.138150, 37.447552, '望岛河游园'],
    [122.118042, 37.372532, '环翠轻户外运动基地（星河露营地）'],
    [122.154758, 37.526290, '半月湾赶海公园'],

    // —————— 文登区 ——————
    [121.783934, 37.185261, '圣经山风景区'],
    [122.209389, 37.236335, '天福山起义纪念馆'],
    [122.091885, 37.194484, '文登学公园'],
    [121.927879, 37.399388, '花驴山生态旅游区'],

    // —————— 荣成市 ——————
    [122.632754, 37.416626, '西霞口神雕山野生动物世界'],
    [122.410360, 37.401465, '那香海钻石沙滩'],
    [122.484938, 37.450367, '鸡鸣岛'],
    [122.643006, 37.412801, '海驴岛'],
    [122.411965, 36.910595, '赤山风景区'],
    [122.467011, 37.147412, '樱花湖体育公园'],
    [122.485929, 37.450877, '东楮岛海草房民居'],

    // —————— 乳山市 ——————
    [121.517655, 36.778050, '大乳山滨海旅游度假区'],
    [121.698744, 36.845538, '银滩旅游度假区'],
    [121.383255, 36.867949, '岠嵎山风景区'],
    [121.731757, 36.879187, '多福山国际养生旅游度假区'],
    [121.708217, 37.010218, '乳山小汤温泉度假村'],
    [121.494321, 36.959228, '台依湖国际酒庄生态文化区'],

    // —————— 经开区 & 临港区 ——————
    [122.135605, 37.489925, '华夏城旅游景区'],
    [122.171745, 37.421860, '九龙城购物广场（含儿童乐园）'],
    [122.252357, 37.425170, '崮山镇葡萄采摘园'],
];

var weihai = [
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    }
]


export default weihai